import numeral from 'numeral';
import $ from 'jquery';
import Api from '../util/Api';

const BasketService = {
    /**
     * @param productId
     * @param quantity
     * @return {*}
     */
    add(productId, quantity) {
        return Api.post('/api/basket/add/', {
            quantity,
            product_id: productId
        });
    },

    /**
     * @param basketItemId
     * @param quantity
     * @return {*|Promise<AxiosResponse<any>>}
     */
    update(basketItemId, quantity) {
        return Api.post('/api/basket/update/', {
            quantity,
            basket_product_id: basketItemId
        });
    },

    /**
     * @return {*|Promise<AxiosResponse<any>>}
     */
    get() {
        return Api.get('/api/basket/');
    },

    formatPrice(price, symbol = '₹') {
        const priceRounded = parseFloat(price).toFixed(2);

        const priceFormatted = numeral(priceRounded).format('0,0.00').replace(/,/g, '');
        return `<span class="india-currency-symbol">${symbol}</span>&nbsp;${priceFormatted}`;
    },

    /**
     *
     */
    render() {
        // let pointsOverall = 0;
        let priceOverall = 0;
        let priceDiscountOverall = 0;
        const $MIN_BASKET_PRICE = $('.cart-result-amount-min-basket-price');
        const $CREATE_ORDER = $('.cart-result__button--create-order');
        const {formatPrice} = this;

        $('.cart-item').each(function () {
            let price = $(this).attr('data-price');
            if (price == 'false') {
                $(this).find('.cart-item__note').removeClass('hidden');
                $(this).find('.cart-item__cell').addClass('hidden');
            } else {
                $(this).find('.cart-item__note').addClass('hidden');
                $(this).find('.cart-item__cell').removeClass('hidden');

                price = parseFloat(price);
                const priceDiscount = parseFloat($(this).attr('data-price-discount'));
                const points = parseFloat($(this).attr('data-points'));
                const quantity = +$(this).find('.quantity__value').val();

                //$(this).find('.cart-item__points').text(`Points: ${numeral(points).format('0[.]0[0]')}`);
                //$(this).find('.cart-item__price').html(formatPrice(price));

                //$(this).find('.cart-item__total-points').text(`Points: ${numeral(points * quantity).format('0[.]0[0]')}`);
                //$(this).find('.cart-item__total-price').html(formatPrice(price * quantity));

                // pointsOverall += points * quantity;
                priceOverall += price * quantity;
                priceDiscountOverall += priceDiscount * quantity;
            }
        });
        console.log(priceDiscountOverall);
        if (priceDiscountOverall < 2500) {
            priceDiscountOverall += 90;
            $('.cart-result-amount__value--delivery').html('<span class="india-currency-symbol">₹</span> 90');
        } else {
            $('.cart-result-amount__value--delivery').html('<span class="india-currency-symbol">₹</span> 0');
        }
        $('.cart-result-amount__value--price').html(formatPrice(priceOverall));
        $('.cart-result-amount__value--price-discount').html(formatPrice(priceDiscountOverall));
        //$('.cart-result__points').html(numeral(pointsOverall).format('0[.]0[0]'));

        // Покажем/скроем уведомление о минимальной стоимости корзины
        setTimeout(()=>{
            if ($('.minimal_summ__disabled').length > 0) {
                const minimalSumm = $('.minimal_summ__disabled').attr('data-minimal-summ');
                $CREATE_ORDER.after('<div class="cart-result-amount cart-result-amount-min-basket-price"><div class="cart-result__text">Minimum order value</div><div class="cart-result__amount"><span class="cart-result-amount__value" data-currency-format="0 0[.]00" data-currency-symbol="₹">' + formatPrice(minimalSumm) + '</span></div></div>');
                $CREATE_ORDER.remove();
            }

            if($('.minimal_summ__enabled').length > 0) {
                $MIN_BASKET_PRICE.after('<a class="button cart-result__button cart-result__button--create-order" href="/order/">Submit</a>');
                $MIN_BASKET_PRICE.remove();
            }
        }, 1500);
    }
};
export default BasketService;
